import { Controller } from "@hotwired/stimulus";

// Shows the org number / company address fields once "Ev. företag" has a
// value, matching the old $("#you_company").on("input", ...) behavior.
export default class extends Controller {
  static targets = ["company", "field"];

  connect() {
    this.sync();
  }

  sync() {
    const hasValue = this.companyTarget.value.trim().length > 0;
    this.fieldTargets.forEach((el) => el.classList.toggle("hidden", !hasValue));
  }
}
